import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { BATTERY_THRESHOLD_SWITCH_ID } from 'src/app/constants/power.constants';

@Component({
	selector: 'vtr-ui-custom-switch',
	templateUrl: './ui-custom-switch.component.html',
	styleUrls: ['./ui-custom-switch.component.scss']
})

export class UiCustomSwitchComponent implements OnInit, OnDestroy {
	public static switchChange: Subject<boolean> = new Subject<boolean>();

	@Output() toggle: EventEmitter<any> = new EventEmitter();
	@Input() value = false;
	@Input() componentId = 'toggle-switch';
	@Input() isDisabled = false;
	@Input() isLoading = false;
	@Input() theme = 'white';
	@Input() readonly = false;
	@Input() label: string;
	@Input() ariaLabel: string;
	@Input() sendMetrics = true;
	@Input() metricsParent;
	@Input() switchParam: string;

	private switchChangeSubscription: Subscription;

	constructor() { }

	ngOnInit(): void {
		this.switchChangeSubscription = UiCustomSwitchComponent.switchChange.subscribe({
			next: value => {
				if (this.componentId === BATTERY_THRESHOLD_SWITCH_ID) {
					this.value = value;
				}
			}
		});
	}

	ngOnDestroy() {
		if (this.switchChangeSubscription) {
			this.switchChangeSubscription.unsubscribe();
		}
	}

	public onChange($event) {
		const value = $event.target.checked;
		this.value = value;
		this.toggle.emit({ switchValue: value });
	}
}
